import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=69d27ae7&scoped=true"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"
import style0 from "./Draft.vue?vue&type=style&index=0&id=69d27ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d27ae7",
  null
  
)

export default component.exports